$(document).ready(function () {
  let brandValue;
  let modelValue;
  let barValue;
  $("#brand").on("change", function() {
    console.log( this.value );
    brandValue = this.value;
    //$('#brand').hide();

    $('#model').prop("disabled", false);
    //$('#model').show();
    //$('#back-btn').removeAttr('disabled');
  });

  $("#model").on("change", function() {
    console.log( this.value );
    modelValue = this.value;
    //$('#model').hide();

    $('#bar').prop("disabled", false);
    //$('#bar').show();
  });

  $("#bar").on("change", function() {
    console.log( this.value );
    barValue = this.value
    $("#find-btn").removeAttr('disabled');
  });

  $("#find-btn").on("click", function(){
    /*if(modelValue.indexOf(' ') >= 0){
      console.log('WHITE');
      modelValue = modelValue.replace(/\s+/g, '');
      console.log(modelValue);
    }*/
    const url = window.location.origin + window.location.pathname + '/';
    
    document.location.href = url + brandValue + '+' + modelValue + '+' +  barValue;
  });

  /*$("#back-btn").on("click", function(){
    $('#brand').show();
    $('#brand-label').show();
    $('#brand').prop('selectedIndex',0);
    $('#model').hide();
    $('#model-label').hide();
    $('#model').prop('selectedIndex',0);
    $('#bar').hide();
    $('#bar-label').hide();
    $('#bar').prop('selectedIndex',0);
  });*/
});